import LazyImage from '@/components/elements/LazyImage';
import VaultIcon from '@/components/elements/VaultIcon';
import Icon, { Icons } from '@/presentation/components/elements/Icon';
import type { Vault } from 'nftx.js';

export const Popular = ({
  vault,
  onClick,
  type,
  imageUrl,
}: {
  vault?: Pick<Vault, 'vaultId' | 'is1155' | 'asset' | 'token' | 'id'>;
  onClick: () => void;
  type: 'token' | 'collection' | 'eth';
  imageUrl?: string;
}) => {
  return (
    <button
      type="button"
      className="rounded-full bg-gray-50 border border-gray-300 hover:bg-pink-500/5 hover:border-pink-500/50 p-1 flex items-center mr-2 mb-1 text-gray-800"
      onClick={onClick}
    >
      {vault ? (
        <>
          {type === 'token' ? (
            <VaultIcon
              vaultId={vault.vaultId}
              className="w-8 h-8 flex-none mr-2 rounded-full"
              alt={vault.token.name}
            />
          ) : (
            <LazyImage
              src={imageUrl}
              className="w-8 h-8 flex-none mr-2 rounded-full"
              alt={vault.token.name}
            />
          )}
        </>
      ) : (
        <>
          {type === 'eth' && (
            <span className="h-8 w-8 flex-none flex rounded-full mr-2 bg-blue-500 items-center justify-center">
              <Icon name={Icons.ETH} className="text-white" size={24} />
            </span>
          )}
        </>
      )}
      <span className="mr-2">
        {vault ? (
          <>{type === 'token' ? vault.token.symbol : vault.token.name}</>
        ) : (
          <>{type === 'eth' && 'ETH'}</>
        )}
      </span>
    </button>
  );
};

export default Popular;
